export default function LoadingState({
  message = "AI is creating your icons...",
  subMessage = "This typically takes 10-20 seconds"
}) {
  return (
    <div className="h-full flex flex-col p-6">
      <div className="flex items-center justify-between mb-6 flex-shrink-0">
        <div className="space-y-2">
          <div className="h-6 w-40 bg-slate-200 dark:bg-white/10 rounded-lg animate-pulse" />
          <div className="h-4 w-28 bg-slate-100 dark:bg-white/5 rounded-md animate-pulse" />
        </div>
        <div className="h-10 w-36 bg-white/50 dark:bg-white/5 rounded-xl animate-pulse border border-slate-200 dark:border-white/10 shadow-sm" />
      </div>

      <div className="flex-1 grid grid-cols-2 gap-4 min-h-0">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="relative bg-white/40 dark:bg-white/[0.02] border border-slate-200/50 dark:border-white/5 rounded-2xl overflow-hidden shadow-inner group"
          >
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center">
                <div className="relative w-16 h-16 mx-auto mb-3">
                  <div className="absolute inset-0 rounded-2xl border-2 border-dashed border-violet-500/20 animate-[spin_4s_linear_infinite]" />
                  <div className="absolute inset-2 rounded-xl bg-gradient-to-br from-violet-500/10 to-fuchsia-500/10 flex items-center justify-center backdrop-blur-sm">
                    <svg className="w-6 h-6 text-violet-500/40 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09z" />
                    </svg>
                  </div>
                </div>
                <p className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500 animate-pulse">Drafting {i}</p>
              </div>
            </div>

            {/* Progress line */}
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-slate-100 dark:bg-white/5 overflow-hidden">
              <div
                className="h-full bg-gradient-to-r from-violet-500 via-fuchsia-500 to-violet-500 bg-[length:200%_100%] animate-[shimmer_2s_infinite_linear]"
                style={{
                  animationDelay: `${i * 0.15}s`
                }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 flex-shrink-0">
        <div className="glass-strong border-violet-500/20 dark:border-violet-400/10 p-4 flex items-center gap-4 animate-fade-in-up">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-violet-500 to-fuchsia-500 flex items-center justify-center flex-shrink-0 shadow-lg shadow-violet-500/20">
            <svg
              className="w-6 h-6 text-white animate-[spin_3s_linear_infinite]"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between mb-1">
              <p className="text-sm font-bold text-slate-800 dark:text-white">{message}</p>
              <span className="text-[10px] font-bold text-violet-500 animate-pulse">Running AI Model...</span>
            </div>
            <p className="text-xs text-slate-500 dark:text-slate-400 font-medium">{subMessage}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

